import notification from "antd/lib/notification";
import Form from "antd/lib/form";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { resetPassword } from "../services/NewAuthService";
import { getImageBaseUrl } from "../services/s3-utils";
import { useQalortSession } from "../hooks/useQalortSession";
import QalortButton from "../components/Button";
import SEO from "../components/Seo";

function ResetPassword(props) {
  const [loading, setLoading] = useState(false);
  const [pwrdType, setPwrdType] = useState(true);
  const { qalortUser } = useQalortSession();
  const { passwordId } = useParams();
  const navigate = useNavigate();

  const onSubmit = async (values) => {
    const { password } = values;
    setLoading(true);
    let data = {
      password,
      confirm_password: password,
      token: passwordId,
    };
    try {
      const response = await resetPassword(data);
      notification.success({
        message: "Password reset successful. Login with your new password",
      });
      navigate("/login");
    } catch (error) {
      notification.error({
        message: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    qalortUser && navigate("/");
  }, []);

  return (
    <>
      <SEO />
      <div className="flex [@media(min-width:987px)]:p-4 h-screen overflow-hidden">
        <div className="w-[41%] h-full bg-pri-tint flex items-center justify-center relative [@media(max-width:986px)]:hidden">
          <Link to="/">
            <img
              src={`${getImageBaseUrl}/assets/logo.svg`}
              className="absolute top-8 left-8"
              alt=""
            />
          </Link>
          <img
            src={`${getImageBaseUrl}/assets/auth.png`}
            className="w-2/3 hidden md:block"
            alt=""
          />
        </div>
        <div className="flex-1 px-5 [@media(max-width:986px)]:pt-4 [@media(min-width:1200px)]:px-20 pt-[92px] [@media(min-width:1330px)]:pl-[146px] [@media(min-width:1330px)]:pr-[135px] h-full overflow-auto mb-20">
          <Link
            to="/"
            className="hidden [@media(max-width:986px)]:flex border-b border-neutral py-4 mb-[34px] pl-5 pr-5 -ml-5 -mr-5"
          >
            <img
              src={`${getImageBaseUrl}/assets/logo.svg`}
              className="h-8 w-[103px]"
              alt=""
            />
          </Link>
          <div className="text-tint absolute top-0 right-0 flex items-center pt-10 [@media(max-width:986px)]:hidden">
            <span>Don’t have an account?</span>
            <Link to="/signup">
              <button className="mx-0 md:mx-4 ml-2 bg-pri-tint-3 border-2 bg-white text-tint text-xs py-2 px-4 flex items-center rounded-md border-pri">
                Sign Up
              </button>
            </Link>
          </div>
          <h1 className="mx-auto text-2xl font-semibold text-dark">
            Welcome back 🙌
          </h1>
          <h3 className="mb-10 text-sm mx-auto text-tint font-light">
            Reset Password
          </h3>

          <Form
            name="normal_login"
            layout="vertical"
            className="login-form mt3"
            onFinish={onSubmit}
          >
            <div className="w-full mt-5">
              <p className="label mb-1 text-main">New Password</p>
              <div className="flex relative w-full">
                <Form.Item
                  className="w-full"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Password!",
                    },
                  ]}
                >
                  <input
                    type={pwrdType ? "password" : "text"}
                    className="main-input h-12 rounded-md w-full focus:outline-none px-3"
                  />
                </Form.Item>
                <img
                  onClick={() => setPwrdType(!pwrdType)}
                  src={`${getImageBaseUrl}/assets/eye.svg`}
                  className="absolute top-3 right-4 pointer z-20"
                  alt=""
                />
              </div>
            </div>

            <QalortButton
              htmlType="submit"
              className="bg-pri px-5 py-4 rounded-lg text-white w-full mt-4 "
              type="primary"
              loading={loading}
            >
              Submit
            </QalortButton>
          </Form>
          <p className="text-light text-base leading-[29px] mt-6">
            {" "}
            <span>Do you have an account?</span>{" "}
            <Link to="/login">
              <button className="pri ">Sign in</button>
            </Link>
          </p>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
